import { httpClient } from './httpClient'
import type { CustomerDto, UpdateCustomerProfileRequest } from '../dto/kunden/CustomerDto'

export const customerApi = {
  getMe: () => httpClient.get<CustomerDto>('/customers/me'),
  updateMe: (request: UpdateCustomerProfileRequest) => httpClient.put<CustomerDto>('/customers/me', request),
  /** Clears the "Neu"-Badge on the "Meine Kontaktfreigaben"-Dashboard-Karte. */
  markContactReleasesSeen: () => httpClient.post<void>('/customers/me/contact-requests/seen'),
  /** Self-service account deletion - requires the current password as a second confirmation
   *  factor (see DeleteAccountDialog). */
  deleteMe: (password: string) => httpClient.delete<void>('/customers/me', { password }),
}
